import { isClient } from '@/utils/isClient';

export class SessionStorage {
  getString(key: string): string | undefined {
    if (!isClient()) {
      console.warn('WARNING: getItem is not available on the server');
      return;
    }

    try {
      return window?.sessionStorage.getItem(key) ?? undefined;
    } catch (e) {
      console.warn('WARNING: getItem failed', e);
    }
  }

  setString(key: string, value: string): void {
    if (!isClient()) {
      console.warn('WARNING: setItem is not available on the server');
      return;
    }

    try {
      window?.sessionStorage.setItem(key, value);
    } catch (e) {
      console.warn('WARNING: setItem failed', e);
    }
  }

  getBoolean(key: string): boolean | undefined {
    const item = this.getString(key);
    return typeof item === 'string' ? item === 'true' : undefined;
  }

  setBoolean(key: string, value: boolean): void {
    this.setString(key, value.toString());
  }
}
